var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('gw-header',{ref:"gwheader",attrs:{"page":"yyhAppInfo"}}),_c('div',{staticClass:"banner"},[_c('img',{staticClass:"banner-img",attrs:{"src":_vm.banner}})]),_c('gw-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }